import React from "react";
import CommunityGameMap from "./logic/CommunityGameMap";
import { mapConfigs } from "./MapConfig/mapConfigs";

export default function CommunityLowVisibility() {
  return <CommunityGameMap config={mapConfigs.communityLowvis} mapType="community" />;
}
